import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';

import { HttpClientModule } from '@angular/common/http';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { UserService } from './user.service';
import { HttpClientAuthServiceService } from './httpServices/http-client-auth-service.service';
import { GetPromissoryNotesByIdService } from './httpServices/get-promissory-notes-by-id.service';
import { UserTestComponent } from './user-test/user-test.component';
import { MerqueComponent } from './merque/merque.component';
import { ContactoComponent } from './contacto/contacto.component';
import { QuienesSomosComponent } from './quienes-somos/quienes-somos.component';
import { RemaxComponent } from './remax/remax.component';
import { ServiciosSolucionesComponent } from './servicios-soluciones/servicios-soluciones.component';
import { PagueAquiComponent } from './Servicios/pague-aqui/pague-aqui.component';
import { ConsultaPagosComponent } from './Servicios/consulta-pagos/consulta-pagos.component';
import { FirmaElectronicaComponent } from './Servicios/firma-electronica/firma-electronica.component';
import { SolicitudCreditoComponent } from './Servicios/solicitud-credito/solicitud-credito.component';
import { PuntoPagoComponent } from './Servicios/punto-pago/punto-pago.component';
import { ErroPageComponent } from './erro-page/erro-page.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { TerminosCondicionesComponent } from './home/terminos-condiciones/terminos-condiciones.component';
import { AceptarTerminosCondicionesComponent } from '../app/home/aceptar-terminos-condiciones/aceptar-terminos-condiciones.component';
import { VirtualPagareComponent } from './Servicios/firma-electronica/virtual-pagare/virtual-pagare.component';
import { HeaderComponent } from './home/header/header.component';
import { FooterComponent } from './home/footer/footer.component';
import { LateralButtonsComponent } from './home/lateral-buttons/lateral-buttons.component';
import { ContactoPageComponent } from './contacto/contacto-page/contacto-page.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    UserTestComponent,
    MerqueComponent,
    ContactoComponent,
    QuienesSomosComponent,
    RemaxComponent,
    ServiciosSolucionesComponent,
    PagueAquiComponent,
    ConsultaPagosComponent,
    FirmaElectronicaComponent,
    SolicitudCreditoComponent,
    PuntoPagoComponent,
    ErroPageComponent,
    TerminosCondicionesComponent,
    AceptarTerminosCondicionesComponent,
    VirtualPagareComponent,
    HeaderComponent,
    FooterComponent,
    LateralButtonsComponent,
    ContactoPageComponent,
  ],
  imports: [BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot()],
  exports: [ContactoComponent],
  providers: [UserService,HttpClientAuthServiceService, GetPromissoryNotesByIdService],
  bootstrap: [AppComponent],
})
export class AppModule {}
